import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Mobile.css';
import { IsMobile } from './utils/Mobile';
import ReactDOM from 'react-dom/client';
import React from 'react';
import App from './App';
import reportWebVitals from './reportWebVitals';

// The mobile site's styles (Mobile.css) apply only under this, so a desktop never gets them
document.documentElement.classList.toggle('tta-mobile', IsMobile);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
